import { acquisitionLabels } from "./acquisition";

/** The gallery's filters other than the sender, as Home.tsx holds them: "" or "all" is off. */
export type OtherFilters = {
  query: string;
  collection: string;
  acquisition: string;
  thread: string;
};

/**
 * What else is narrowing the gallery while it is filtered to one sender, for the "Postcards
 * from" bar: "also narrowed to “art” and Moomin", or "" when the sender is the only filter.
 *
 * A tap on a name leaves the other filters standing (Joey's choice on #74), so without
 * this the bar over two of Marta's "art" cards reads as everything Marta sent. A place is
 * left out: it has its own bar, right above this one. Each filter is named the way its own
 * control shows it — the search text in quotes, the dropdowns by their option labels.
 */
export function alsoNarrowedTo(filters: OtherFilters, threads: readonly { key: string; label: string }[]) {
  const query = filters.query.trim();
  const names = [
    query && `“${query}”`,
    filters.collection !== "all" && filters.collection,
    filters.acquisition !== "all" && (acquisitionLabels[filters.acquisition] ?? filters.acquisition),
    filters.thread !== "all" && (threads.find((option) => option.key === filters.thread)?.label ?? filters.thread),
  ].filter((name): name is string => Boolean(name));
  if (names.length === 0) return "";
  const list = names.length === 1 ? names[0] : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
  return `also narrowed to ${list}`;
}
